// extracted by mini-css-extract-plugin
export default {"date":"SurveysTablePeriod_date__zFwBj","placeHolderShimmer":"SurveysTablePeriod_placeHolderShimmer__4muSE"};